import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface FacebookIconProps extends IconWrapperProps {
  backFillColor: string;
  frontFillColor: string;
}

const FacebookIcon = ({ backFillColor, frontFillColor, ...rest }: FacebookIconProps) => (
  <span>
    <IconWrapper width="40px" viewBox="0 0 40 40" title="Facebook Link" {...rest}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <rect fill={backFillColor} x="0" y="0" width="40px" height="40px" rx="20" />
          <g transform="translate(14.000000, 10.000000)" fill={frontFillColor} fillRule="nonzero">
            <path d="M10.0445312,11.25 L10.6,7.63046875 L7.12695312,7.63046875 L7.12695312,5.28164063 C7.12695312,4.29140625 7.61210937,3.32617188 9.16757812,3.32617188 L10.7464844,3.32617188 L10.7464844,0.24453125 C10.7464844,0.24453125 9.31367188,0 7.94375,0 C5.08359375,0 3.2140625,1.73359375 3.2140625,4.871875 L3.2140625,7.63046875 L0.034765625,7.63046875 L0.034765625,11.25 L3.2140625,11.25 L3.2140625,20 L7.12695312,20 L7.12695312,11.25 L10.0445312,11.25 Z" />
          </g>
        </g>
      </g>
    </IconWrapper>
  </span>
);

export default memo(FacebookIcon);
